export default "__VITE_ASSET__DoVEJAf___"